module.exports = __webpack_public_path__ + "static/media/vegbiryani.a437a862.jpg";